import type { ReactNode } from 'react'
import { Button } from '@/components/Button'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentDescription,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
} from '@/components/ModalSheet'

export interface PaymentMethodSelectorDialogProps {
  showing: boolean
  isDisabled?: boolean
  onClose: () => unknown
  children?: ReactNode
}

export function PaymentMethodSelectorDialog({
  showing,
  isDisabled,
  onClose,
  children,
}: PaymentMethodSelectorDialogProps) {
  return (
    <ModalSheet
      showing={showing}
      onRequestClose={isDisabled ? undefined : onClose}
    >
      <ModalSheetHeader withCloseButton />
      <ModalSheetContent>
        <ModalSheetContentBlock>
          <ModalSheetContentTitle>Select Payment Method</ModalSheetContentTitle>
          <ModalSheetContentDescription>
            Select your desired payment method from the list below.
          </ModalSheetContentDescription>
        </ModalSheetContentBlock>
        <ModalSheetContentBlock>{children}</ModalSheetContentBlock>
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button label="Close" isDisabled={isDisabled} onPress={onClose} />
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
}
